'use client';

import {useStableCallback} from '@hooks/useStableCallback';
import {usePathname, useSearchParams} from 'next/navigation';
import {useUpdateEffect} from './useUpdateEffect';

export const useRunOnNavigationEnd = (fn: () => void) => {
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const run = useStableCallback(fn);

    useUpdateEffect(() => {
        run();
    }, [pathname, searchParams, run]);
};
